import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {LoadsService} from 'src/app/services/loads/loads.service';
import {WarehouseService} from 'src/app/services/warehouse/warehouse.service';
import {CategoriesService} from '../../../services/categories/categories.service';
import {WhStockModel} from '../../../models/loads/wh-stock.model';
import {SimpleEntity} from '../../../models/simple-entity.model';
import {WhCategoriesModel} from '../../../models/categories/wh-categories.model';
import {Workbook} from 'exceljs';
import * as fs from 'file-saver';
import {ListService} from "../../../services/list/list.service";

@Component({
  selector: 'app-wh-stock-list',
  templateUrl: './wh-stock-list.component.html',
  styleUrls: ['./wh-stock-list.component.scss'],
})
export class WhStockListComponent implements OnInit {

    isLoading: boolean = true;
    products: WhStockModel[] = [];
    uniqueProducts: SimpleEntity[] = [];
    warehouses: SimpleEntity[] = [];
    product: any = null;
    productCode: SimpleEntity = <any> {};
    project: number;
    productBrand: SimpleEntity = <any> {};
    lastPageSize : number = 0;
    productsForExcel : WhStockModel[]= [];
    projects : any[];

    filteredWarehouse: SimpleEntity[] = [];
    selectedWarehouse: SimpleEntity = <any> {};
    selectedCategory: WhCategoriesModel = null;
    selectedProductType: any;

    categoryItems: MenuItem[] = [];
    categories: WhCategoriesModel[] = [];
    imageDisplay: boolean = false;
    photoData: string = null;
    first = 0;
    totalCount: any = 0;
    downloadStart: any = false;
    excelProgress: number = 0;

    constructor(private messageService: MessageService,
                private confirmationService: ConfirmationService, private warehouseService: WarehouseService,
                private categoriesService: CategoriesService, private loadService: LoadsService) {
    }

    async ngOnInit() {
        await this.getLoadStocks(0);
        await this.getCategories();
        this.projects = await this.loadService.getWhProjects().toPromise();
    }

    async getCategories() {

        this.categories = await  this.categoriesService.getCategories().toPromise();
        const catList:MenuItem[] = [];

        if(this.categories) {
            this.categories.forEach(c => {
                const category = { label: c.name, icon: 'pi pi-angle-right', items: [], command: (event) => { this.searchByCategory(c)}};

                if(c.whCategories && c.whCategories.length > 0) {
                    c.whCategories.forEach(cc => {
                        category.items.push({label: cc.name, command: (event) => { this.searchByCategory(cc)}})
                    })
                }
                catList.push(category)
            })
        }
        this.categoryItems = catList;
    }

    getLoadStocks(page: number){
        this.isLoading = true;
        this.loadService.searchwhProductWithResponse(this.selectedWarehouse?.id, this.selectedProductType, this.selectedCategory?.id, this.product?.name ? this.product.name : this.product, this.productCode?.name, null,this.project ,true, page).subscribe(res => {
            this.products = res.body;
            this.totalCount = res.headers.get('Total-Elements');
            this.lastPageSize = Number(res.headers.get('Total-Page-Count'));
            this.isLoading = false;
            if(this.uniqueProducts.length == 0 && this.products) {
                this.uniqueProducts = this.products.map(s => s.whProduct).filter((a, i) => this.products.map(s => s.whProduct).findIndex((s) => a.id === s.id) === i)
            }
        });

    }
    getLoadStocksForExcel(page: number, workbook:Workbook){
        if (page != this.lastPageSize) {
        this.downloadStart = true;
        this.excelProgress = (100 / this.lastPageSize) * page;
        var worksheet = workbook.getWorksheet('Main sheet')
        this.isLoading = true;
        this.loadService.searchwhProductWithResponse(this.selectedWarehouse?.id, this.selectedProductType, this.selectedCategory?.id, this.product?.name ? this.product.name : this.product, this.productCode?.name, null, this.project,true, page).subscribe(res => {
            const body = res.body
            this.lastPageSize = Number(res.headers.get('Total-Page-Count'));
            for (const data of body){
                const barcodes = data.barcodes?.join('-');
                worksheet.addRow({
                    name: data.globalName,
                    code: data.code,
                    barcode: barcodes,
                    globalName: data.whProduct.name,
                    stock: this.getTotalStockByStocks(data),
                    whCategoryName: data.whCategoryName,
                    whProjectName: data.whProjectName,
                    lastActionDate: data.lastActionDate,
                    measureUnit: data.measureUnit
                });
                worksheet.lastRow.height = 160;
                this.productsForExcel.push(data);
                if (data.photo){
                    const image = workbook.addImage({
                        base64: data.photo,
                        extension: 'png',
                    });
                    const index = this.productsForExcel.indexOf(data) + 2;
                    console.log(index);
                    worksheet.addImage(image, 'G' + index + ':' + 'G' + index);
                }

            }
            page++;
            this.getLoadStocksForExcel(page, workbook);
        });
        }else {
            this.excelProgress = 100;
           const val =workbook.xlsx.writeBuffer().then(function (buffer){
                let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fs.saveAs(blob, 'Stok Listesi - ' + new Date().toLocaleDateString() + ' ' + new Date().toTimeString() + '.xlsx');
            }).then(() => {
                this.downloadStart = false
               this.isLoading = false;
            });

        }
    }


    searchByCategory(category: any ) {
        this.selectedCategory = category;
        this.getLoadStocks(0)
    }


    async exportToExcel() {
        var workbook = new Workbook();
        var worksheet = workbook.addWorksheet('Main sheet');

        this.isLoading = true;
        this.isLoading = false;
        this.productsForExcel = [];

        worksheet.columns = [
            { header: 'Ürün Adı', key: 'name', width: 30 },
            { header: 'Ürün Global İsmi', key: 'globalName', width: 30 },
            { header: 'Ürün Kodu-1', key: 'code', width: 30 },
            { header: 'Barkod', key: 'barcode', width: 30 },
            { header: 'Kullanılabilir Stok', key: 'stock', width: 20},
            { header: 'Ölçü Birimi', key: 'measureUnit', width: 20},
            { header: 'Kategori Adı', key: 'whCategoryName', width: 20},
            { header: 'Proje Adı', key: 'whProjectName', width: 20},
            { header: 'Son Hareket Tarihi', key: 'lastActionDate', width: 20},
            { header: 'Ürün Resmi', key: 'image', width: 20 }

        ];

        worksheet.properties.defaultRowHeight = 160;

       this.getLoadStocksForExcel(0,workbook);


    }

    showDialog(photoData) {
        if (photoData) {
            this.photoData = photoData;
            this.imageDisplay = true;
        }
    }
    refresh() {
        this.first = 0;
    }

    getTotalStockByStocks(mainStock: WhStockModel) {
        if (mainStock.stocks) {
            let totalStock = 0;
            mainStock.stocks.forEach(stock => {
                totalStock += stock.stock;
            });
            return totalStock;
        }
        return mainStock.stock;
    }

    onPage(event: any) {
        this.getLoadStocks(event.first / 10);
    }

}
